export class UserProfile {
    Id: number;
    UserId: number;
    FirstName: string;
    LastName: string;
    IsAdmin: boolean;
    IsCandidate: boolean;
    IsRecruiter: boolean;
    Email: string;
    ProfileViews: number;
    UserConnections: number;
    ProfileImagePath: string;
    OtherInformation: string;
    PersonalSummary: string;
    IsCvReviewed: boolean;
    IsFmCvRegistration: boolean;
    IsCvLibraryRegistration: boolean;
    VideoScreeningStatus: number;
    IsExpertScreening: boolean;
    IsProfilePrivate: boolean;
    IsSearchable: boolean;
    IsShowCompanyInfo: boolean;
    VerificationTypeId: number;
    IsShowRecruiterName: boolean;
    ConnectionRequest: number;
    PendingConnectionRequest: number;
}